export default {
  methods: {
    onBlur() {
      this.$refs.provider.setFlags({
        touched: true,
        untouched: false
      })
    },
    onInput(val) {
      this.$emit('modified', val)
      this.$emit('input', val)
      this.$refs.provider.syncValue(val);
      this.$refs.provider.setErrors([])
      this.$refs.provider.setFlags({
        pristine: false,
        dirty: true
      })
    }
  }
}
